import React from 'react';
import { LogOut, Video } from 'lucide-react';
import '../styles/CustomMeetingRoom.css'

export default function TopSection({ studentName, grade, onLogout, classlink }) {
  return (
    <header className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row sm:justify-between sm:items-center">
        <div className="mb-4 sm:mb-0">
          <h1 className="text-3xl font-bold text-gray-900">{studentName}</h1>
          <p className="mt-1 text-sm text-gray-600">Grade: {grade}</p>
        </div>
        <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
        <button
        onClick={() => {
          if (window.confirm('After clicking on link, Please enter your own name and click on “Wait For Moderator” and kindly wait for the teacher to let you in')) {
            window.open(classlink, '_blank');
          }
        }}
        disabled={!classlink}
        className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Video className="mr-2 h-4 w-4" />
        Join Class
      </button>
          <button
            onClick={onLogout}
            className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}